import { css } from '@emotion/css'
import { breakpoint, mediaQueryHelper } from '@offerzen/pinata'

import { navbarHeight } from '../Navbar'

const styles = {
  wrapper: css({
    paddingTop: navbarHeight,

    [mediaQueryHelper(breakpoint.tablet)]: {
      paddingTop: 0,
    },
  }),
}

export default styles
